import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { watchBuildVersion } from "@shared/client/build-version";
import { startLocale } from "@shared/client/locale";
import { Providers } from "@shared/client/providers";
import { router } from "./router";
import "./app.css";

startLocale();
watchBuildVersion(router);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
